import React from "react";
import { SectionBadge } from "./Comparison";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "Will checking eligibility affect the business credit file?", a: "No. Our initial eligibility check is a soft search — invisible to other lenders and with no footprint on the business file or the directors' personal files." },
  { q: "How quickly can we get funded?", a: "Indicative terms typically inside the hour. Signed offers within 24 hours. Drawdown from 24 hours (unsecured working capital, asset finance) up to 4–6 weeks for commercial mortgages that require valuation & legals." },
  { q: "What's the real cost of the loan?", a: "Rates are bespoke. Unsecured working capital typically 8.9–19.9% APR. Asset finance 6.9–12%. Commercial mortgages 5.9–8.9%. Invoice finance 1.5–4% per month. Bridging from 0.55%/month. Final rate depends on turnover, security, sector and trading history — always disclosed up-front, never adjusted at signing." },
  { q: "How much can we borrow?", a: "£5,000 to £500,000,000 across our funding panel. Terms from 1 to 120 months (25 years on commercial mortgages). What you actually qualify for depends on affordability, security available and your business profile." },
  { q: "Do we need to be trading for X years?", a: "No hard rule. We fund pre-revenue growth-stage businesses (invoice finance, asset finance, growth capital), businesses in their first 12 months, and £100M+ turnover groups. Underwriting is deal-by-deal." },
  { q: "Will directors need to sign personal guarantees?", a: "It depends on the product, amount and security. On asset-backed and property lending we can usually avoid PGs entirely. On unsecured working capital most lenders require a limited PG — we prioritise structures that minimise director exposure." },
  { q: "Can we settle early?", a: "Most facilities can be settled early without penalty. We'll flag any early-settlement fees clearly on the term sheet — you decide whether to accept them before signing." },
  { q: "What if our credit history isn't perfect?", a: "We work with a specialist panel that funds adverse credit, CCJs, arrears and previously declined applications. We look at current affordability and security, not just historical file data." },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative bg-white py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <SectionBadge>Got questions?</SectionBadge>
          <h2 className="font-display font-extrabold text-[40px] md:text-[56px] leading-[1.02] tracking-[-0.035em] text-navy mt-5">
            Frequently asked <br />
            <span className="text-emerald">questions.</span>
          </h2>
          <p className="mt-6 text-[16px] text-navy/65 font-medium">Straight answers before you check eligibility.</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-2xl border border-line bg-paper-warm px-6 md:px-7 data-[state=open]:border-emerald/40 data-[state=open]:bg-sage/30 transition-colors"
              >
                <AccordionTrigger
                  className="py-6 text-left font-display font-extrabold text-[16px] md:text-[18px] tracking-[-0.015em] text-navy hover:no-underline"
                  data-testid={`faq-q-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[15px] leading-[1.7] text-navy/70 font-medium">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
